import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/actions'
import { getSelectedProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/selectors'
import VALUES from 'core/data-model/constants/values'

export const RokeRaiSoShieldLifeProtectPlusProductSelection = ({
  getSelectedProductLifeProtectPlus,
  selectProductLifeProtectPlus,
}) => {
  const productRokeRaiSoShieldLifeProtectPlus = [
    {
      text: '9 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_LIFEPROTECT_PLUS_CODE.WLF09H,
    },
    {
      text: '19 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_LIFEPROTECT_PLUS_CODE.WLF19H,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.ROKE_RAI_SO_SHIELD_LIFEPROTECT_PLUS_CODE.WLF99H,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeProtectPlus}
        value={getSelectedProductLifeProtectPlus}
        options={productRokeRaiSoShieldLifeProtectPlus}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductLifeProtectPlus: getSelectedProductLifeProtectPlus(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeProtectPlus: bindActionCreators(selectProductLifeProtectPlus, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(RokeRaiSoShieldLifeProtectPlusProductSelection)
